import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  loading: false,
  error: null,
  preferences: {
    dietaryType: [], // ['veg', 'non-veg', 'jain']
    mealTypes: [], // ['breakfast', 'lunch', 'dinner']
    cuisineStyles: [], // ['healthy', 'fried', 'kids-special']
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user || null;
      state.token = action.payload.token || null;
      // Safely access preferences to avoid null reference errors
      state.preferences = (action.payload.user && action.payload.user.preferences) ? action.payload.user.preferences : initialState.preferences;
      if (action.payload.token) {
        localStorage.setItem('token', action.payload.token);
      }
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.preferences = initialState.preferences;
      localStorage.removeItem('token');
    },
    updatePreferences: (state, action) => {
      state.preferences = {
        ...state.preferences,
        ...action.payload,
      };
    },
  },
});

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout,
  updatePreferences 
} = authSlice.actions;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectIsAdmin = (state) => state.auth.user?.role === 'admin';
export const selectPreferences = (state) => state.auth.preferences;

export default authSlice.reducer;
